<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-form-item label="商品名称" prop="commodityType">
        <el-select v-model="dataForm.commodityType" placeholder="请选择商品">
          <el-option v-for="item in commodityList" :key="item.id" :label="item.duration" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区块链" prop="chainId">
        <el-select v-model="dataForm.chainId" placeholder="请选择区块链" @change="chainChangeHandle">
          <el-option v-for="item in chainList" :key="item.id" :label="`${item.chainName} (${item.chainCode})`" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代币" prop="tokenId">
        <el-select v-model="dataForm.tokenId" placeholder="请选择代币">
          <el-option v-for="item in tokenList" :key="item.id" :label="`${item.tokenName} (${item.tokenCode})`" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品价格" prop="price">
        <el-input-number v-model="dataForm.price" :precision="2" :min="0" placeholder="商品价格"></el-input-number>
      </el-form-item>
      <el-form-item label="商品排序" prop="sortOrder">
        <el-input-number v-model="dataForm.sortOrder" :min="0" placeholder="商品排序"></el-input-number>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="dataForm.remark" type="textarea" :rows="3" placeholder="备注信息"></el-input>
      </el-form-item>
      <el-form-item label="是否开启" prop="status">
        <el-radio-group v-model="dataForm.status">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      chainList: [],
      tokenList: [],
      commodityList: [],
      dataForm: {
        id: '',
        chainId: '',
        tokenId: '',
        price: 0,
        sortOrder: 0,
        remark: '',
        commodityType: '',
        status: 1
      }
    }
  },
  computed: {
    dataRule () {
      return {
        commodityType: [{ required: true, message: this.$t('validate.required'), trigger: 'change' }],
        chainId: [{ required: true, message: this.$t('validate.required'), trigger: 'change' }],
        tokenId: [{ required: true, message: this.$t('validate.required'), trigger: 'change' }],
        price: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        sortOrder: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        status: [{ required: true, message: this.$t('validate.required'), trigger: 'change' }]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.getCommodityList()
        this.getChainList()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    getCommodityList () {
      this.$http.get('/commodity/commodity/all').then(({ data: res }) => {
        if (res.code === 0) this.commodityList = res.data
      }).catch(() => {})
    },
    getChainList () {
      this.$http.get('/crypto/chain/enabled').then(({ data: res }) => {
        if (res.code === 0) this.chainList = res.data
      }).catch(() => {})
    },
    chainChangeHandle (chainId) {
      // 清空代币选择
      this.dataForm.tokenId = ''
      this.tokenList = []
      if (!chainId) return

      // 根据区块链ID查询该链下的代币
      this.$http.get(`/crypto/token/byChain/${chainId}`).then(({ data: res }) => {
        if (res.code === 0) {
          this.tokenList = res.data
        }
      }).catch(() => {})
    },
    getInfo () {
      this.$http.get(`/crypto/commodity/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code === 0) {
          // 后端返回的DTO包含chainId
          this.dataForm = { ...this.dataForm, ...res.data }

          // 如果有chainId,加载对应的代币列表(不清空tokenId,因为要保持当前选择)
          if (this.dataForm.chainId) {
            const currentTokenId = this.dataForm.tokenId
            this.$http.get(`/crypto/token/byChain/${this.dataForm.chainId}`).then(({ data: res }) => {
              if (res.code === 0) {
                this.tokenList = res.data
                // 恢复tokenId
                this.dataForm.tokenId = currentTokenId
              }
            }).catch(() => {})
          }
        }
      }).catch(() => {})
    },
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) return false
        this.$http[!this.dataForm.id ? 'post' : 'put']('/crypto/commodity', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) return this.$message.error(res.msg)
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
